import { Component } from '@angular/core';
import {DropzoneComponent} from "@ngx-dropzone/cdk";

@Component({
  selector: 'brt-custom-dropzone',
  templateUrl: './custom-dropzone.component.html',
  styleUrls: ['./custom-dropzone.component.scss']
})
export class CustomDropzoneComponent extends DropzoneComponent {

}
